import { render } from "./PlayView.vue?vue&type=template&id=33d0a526&ts=true"
import script from "./PlayView.vue?vue&type=script&lang=ts"
export * from "./PlayView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Plays/PlayView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33d0a526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33d0a526', __exports__)) {
    api.reload('33d0a526', __exports__)
  }
  
  module.hot.accept("./PlayView.vue?vue&type=template&id=33d0a526&ts=true", () => {
    api.rerender('33d0a526', render)
  })

}


export default __exports__